module.exports = __webpack_public_path__ + "img/blankscreen_300.0e042422.jpg";